import { Activity, Box, Layers, ShieldCheck, FileText } from 'lucide-react';
import { useViewerStore } from '@/state/viewerStore';

export function StatusBar() {
  const modelName = useViewerStore((s) => s.modelName);
  const stats = useViewerStore((s) => s.stats);

  if (!modelName) return null;

  const trianglesFmt = formatNumber(stats.triangles);
  const fpsColor =
    stats.fps >= 50 ? 'text-emerald-400' : stats.fps >= 30 ? 'text-amber-400' : 'text-red-400';

  return (
    <footer className="pointer-events-auto absolute inset-x-3 bottom-3 z-20 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-panel-border bg-panel/85 px-3 py-1.5 text-xs backdrop-blur">
      <div className="flex items-center gap-4">
        <Item icon={<FileText className="h-3.5 w-3.5" />}>
          <span className="text-foreground">{modelName}</span>
        </Item>
        <Item icon={<Box className="h-3.5 w-3.5" />}>
          {stats.visibleMeshes} / {stats.totalMeshes} meshes
        </Item>
        <Item icon={<Layers className="h-3.5 w-3.5" />}>{trianglesFmt} tris</Item>
        <Item icon={<Activity className="h-3.5 w-3.5" />}>
          {stats.idle ? (
            <span className="text-muted" title="Rendering on demand — nothing is moving">
              idle
            </span>
          ) : (
            <span className={fpsColor}>{stats.fps} fps</span>
          )}
        </Item>
      </div>
      <div className="flex items-center gap-1.5 text-emerald-400/90">
        <ShieldCheck className="h-3.5 w-3.5" />
        <span>Local — never uploaded</span>
      </div>
    </footer>
  );
}

function Item({ icon, children }: { icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="flex items-center gap-1.5 text-muted">
      <span className="text-muted/70">{icon}</span>
      {children}
    </div>
  );
}

function formatNumber(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
  return String(n);
}
